
export const initialValues = {
  stateId: "",
  districtId: "",
  cityName: "",
  countryId: "",
  activeStatus: 1,
}